module.exports = "../../../../platform/assets/pageMainIcon/simple_yewushezhilei5.svg";